import React, { useEffect, useState } from "react";
import TableLoader from "../../../Skeleton/TableLoader";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import Pagination from "../../../utils/Paginate";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ListContentIndices = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentIndices: [],
    filteredContentIndices: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(`${globalConfig.apiDatahubUrl}/content-indices `, apiHeader(token))
      .then((res) => {
        const contentIndices = res.data;
        console.log(contentIndices);
        setState({
          ...state,
          contentIndices: contentIndices,
          filteredContentIndices: contentIndices,
        });
        setLoading(false);
        console.log(res.data[0]);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-indices/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({ ...state, contentIndices: [], filteredContentIndices: [] });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({ ...state, contentIndices: [], filteredContentIndices: [] });
    handleOnLoad();
    // this.props.history.push("/list-content-indices");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-indices?filter[limit]=50`;
    URL += `&filter[where][or][0][contentIndexName][regexp]=/(${search})/i&filter[where][or][1][contentIndexDescr][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentIndices = res.data;
      console.log(contentIndices);
      setState({ ...state, filteredContentIndices: contentIndices });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };
  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentIndices.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>
    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Indices</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        	<Link to="/breeze/create-content-index">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-index-types">
          <Button
            variant="contained"
            color="warning"
          >
            Types
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

      <div className="container-fluid">
        
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Type</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentIndexId,
                    contentIndexName,
                    contentIndexDescr,
                    contentIndexTypeId,
                  }) => {
                    return (
                      <tr>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-indices",
                              search: `?id=${contentIndexId}`,
                            }}
                          >{contentIndexId}</Link></td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-indices",
                              search: `?id=${contentIndexId}`,
                            }}
                          >{contentIndexName}</Link> </td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-indices",
                              search: `?id=${contentIndexId}`,
                            }}
                          > {contentIndexDescr}</Link></td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-indices",
                              search: `?id=${contentIndexId}`,
                            }}
                          > {contentIndexTypeId}</Link></td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-indices",
                              search: `?id=${contentIndexId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentIndexId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(5).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentIndices.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />
      </div>
    </form>
  );
};

export default ListContentIndices;
